import React, { useState } from 'react';
import { Logo } from './Logo';
import { ChevronDown, Facebook } from 'lucide-react';
export function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);
  return <footer className="bg-text text-white py-16" data-id="element-35">
      <div className="max-w-6xl mx-auto px-4" data-id="element-36">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-37">
          {/* Left */}
          <div className="space-y-4" data-id="element-38">
            <div className="flex items-center gap-3" data-id="element-39">
              <Logo className="w-8 h-8 text-white" data-id="element-40" />
              <span className="font-serif text-xl font-bold" data-id="element-41">
                El Código del Bienestar
              </span>
            </div>
            <p className="text-accent italic opacity-90 max-w-xs" data-id="element-42">
              Tu cuerpo tiene un código.
              <br data-id="element-43" />
              Aquí te ayudamos a descifrarlo.
            </p>
          </div>

          {/* Center */}
          <div data-id="element-44">
            <h3 className="font-bold text-lg mb-4 text-white" data-id="element-45">Legal</h3>
            <div className="space-y-2" data-id="element-46">
              <button className="flex items-center gap-2 text-accent hover:text-accent/80 transition-colors focus:outline-none" onClick={() => setLegalOpen(!legalOpen)} data-id="element-47">
                <span data-id="element-48">Documentos legales</span>
                <ChevronDown className={`w-4 h-4 transition-transform ${legalOpen ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>

              <div className={`pl-4 space-y-2 border-l border-white/20 overflow-hidden transition-all duration-300 ${legalOpen ? 'max-h-24 pt-2 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-50">
                <a href="#" className="block text-sm text-accent hover:text-white transition-colors" data-id="element-51">
                  Política de Privacidad
                </a>
                <a href="#" className="block text-sm text-accent hover:text-white transition-colors" data-id="element-52">
                  Términos y Condiciones
                </a>
              </div>
            </div>
          </div>

          {/* Right */}
          <div data-id="element-53">
            <h3 className="font-bold text-lg mb-4 text-white" data-id="element-54">Síguenos</h3>
            <a href="#" className="inline-flex items-center gap-2 text-white/80 hover:text-white transition-colors" data-id="element-55">
              <Facebook className="w-5 h-5 text-accent" data-id="element-56" />
              <span data-id="element-57">@ElCódigoDelBienestar</span>
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-accent" data-id="element-58">
          <p data-id="element-59">© 2026 El Código del Bienestar.</p>
          <p data-id="element-60">⚕️ Contenido informativo. No reemplaza consejo médico.</p>
        </div>
      </div>
    </footer>;
}